import React, { FC } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { HelmetProvider } from 'react-helmet-async';
import { ConfigProvider } from 'antd';
import ruRU from 'antd/lib/locale/ru_RU';
import { TendUI } from '@10d/tend-ui/theme';
import { Normalize } from '@10d/tend-ui-styling';

import { YMetrika } from 'components/YMetrika';

import { instance } from 'api/axiosClient';

import { AuthProvider } from './providers';

import { store } from 'store';

import 'antd/dist/reset.css';
import 'dayjs/locale/ru';
import './dayjsExt.ts';

// Инициализация приложения
TendUI.init();

export const AppWrapper: FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <>
      <TendUI client={instance}>
        <Normalize />
        <Provider store={store}>
          <HelmetProvider>
            <ConfigProvider
              locale={ruRU}
              theme={{
                token: {
                  fontFamily: 'Museo Sans Cyrl',
                },
                components: {
                  Table: {
                    cellPaddingInlineMD: 12,
                  },
                },
              }}
            >
              <BrowserRouter>
                <AuthProvider>{children}</AuthProvider>
              </BrowserRouter>
            </ConfigProvider>
          </HelmetProvider>
        </Provider>
      </TendUI>

      <YMetrika />
    </>
  );
};
